import { Directive, Renderer2, ElementRef, HostListener } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Directive({
	selector: '[appGeneric]'
})
export class GenericDirective {
	subHeader: { icon: string, title: string, breadcrums: any[] } = { icon: 'fa fa-home', title: '', breadcrums: [] };
	constructor(
		private elementRef: ElementRef,
		private renderer: Renderer2
	) { }

	@HostListener('window:unload', ['$event'])
	onPageLoad() {
		window.scrollTo(0, 0);
	}

	norecordsFound(arrayLength: number, textToDisplay?: string) {
		this.renderer.destroy();
		if (arrayLength === 0) {
			const heading = this.renderer.createElement('strong');
			const text = this.renderer.createText(textToDisplay ? textToDisplay : 'No Records Found');
			this.renderer.setStyle(this.elementRef.nativeElement, 'margin-left', '25px');
			this.renderer.setStyle(this.elementRef.nativeElement, 'font-size', '18px');
			this.renderer.appendChild(heading, text);
			this.renderer.setStyle(this.elementRef.nativeElement, 'margin-top', '10px');
			this.renderer.appendChild(this.elementRef.nativeElement, heading);
		}
	}

	setSubHeader(header?: any) {
		this.subHeader = header;
		this.renderer.appendChild(this.elementRef.nativeElement, '<div>Hello Arpitha Somann</div>');
	}

}
